import { styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const PreviewQuestionWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "16px",
  backgroundColor: colors.gray50,
  borderBottom: `1px solid ${colors.gray200}`,
}));

export const PreviewQuestionContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const PreviewQuestionTitle = styled("span")(() => ({
  fontSize: "16px",
  fontWeight: 700,
  color: colors.gray600,
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const PreviewQuestionDescription = styled("span")(() => ({
  fontSize: "14px",
  fontWeight: 400,
  color: colors.gray500,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const Mandatory = styled("span")(() => ({
  color: colors.error500,
}));

const styles = makeStyles(() => ({
  radioGroup: {
    "& > div > label > span.MuiRadio-root": {
      padding: "5px",
      margin: "0 5px",
    },
  },
}));

export default styles;
